<form>  
    <agm-map style="height: 300px;" [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapClick)="mapClicked($event)">  
    <agm-marker  [latitude]="lat" [longitude]="lng"></agm-marker>  
          </agm-map>  
  </form> 